/* eslint-disable */

import COS from "cos-js-sdk-v5";
import { getAvatarToken } from "../api/account";
import { getTeamAvatarToken } from "../api/team";
export function getUserAvatarUploadCOS(token: string) {
  return new COS({
    getAuthorization: (options, callback) => {
      getAvatarToken(token).then((data) => {
        const credentials = data && data.credentials;
        if (!data || !credentials) return console.error("credentials invalid");
        callback({
          TmpSecretId: credentials.tmpSecretId,
          TmpSecretKey: credentials.tmpSecretKey,
          XCosSecurityToken: credentials.sessionToken,
          // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
          StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
          ExpiredTime: data.expiredTime, // 时间戳，单位秒，如：1580000900
        });
      });
    },
  });
}
export function getTeamAvatarUploadCOS(token: string, contestId: number, trackId: number, teamId: number): COS {
  return new COS({
    getAuthorization: (options, callback) => {
      getTeamAvatarToken(token, contestId, trackId, teamId).then((data) => {
        const credentials = data && data.credentials;
        if (!data || !credentials) {
          //if (data) console.log(data);
          return console.error("credentials invalid");
        }
        callback({
          TmpSecretId: credentials.tmpSecretId,
          TmpSecretKey: credentials.tmpSecretKey,
          XCosSecurityToken: credentials.sessionToken,
          // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
          StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
          ExpiredTime: data.expiredTime, // 时间戳，单位秒，如：1580000900
        });
      });
    },
  });
}
